import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=683497e0&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=683497e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683497e0",
  null
  
)

export default component.exports